import { TCondition } from './dataModel';
import { createAction } from '@reduxjs/toolkit';

export const allFiltersRemoved = createAction<void, 'general/filter/ALL_FILTERS_REMOVED'>(
  `general/filter/ALL_FILTERS_REMOVED`,
);

export const filterConditionApplied = createAction<
  { fieldID: string; condition: TCondition },
  'general/filter/FILTER_CONDITION_APPLIED'
>('general/filter/FILTER_CONDITION_APPLIED');
